/**
 * sqft-calculator-patch.js
 * Plank & Loom – sqft calculator UI + form intercept
 *
 * Features:
 *  1. Adds a result line below the sqft input showing
 *     "X boxes × Y sqft/box = Z sqft  (N sqft surplus)"
 *  2. Re-runs calculation after cart update (fixes qty reset to 1)
 *  3. Intercepts the add-to-cart form submit and converts
 *     the sqft value entered by the customer into whole boxes
 *     before Shopify processes the cart (no Shopify Plus needed)
 *
 * Required HTML attributes (set in your product form liquid):
 *  - Wrapper element:  data-sqft-per-box="{{ product.metafields.custom.sqft_per_box }}"
 *                  OR  data-sqftperbox="{{ product.metafields.custom.sqft_per_box }}"
 *  - Sqft input:       data-sqft-input  (the visible field the customer types into)
 *  - Hidden qty field: name="quantity"  (the real Shopify quantity input)
 */
(function () {
  'use strict';

  var RESULT_CLASS = 'sqft-calc-result';
  var RESULT_STYLE = [
    'font-size:0.85em',
    'color:#555',
    'margin-top:4px',
    'line-height:1.4'
  ].join(';');

  /* — helpers ——————————————————————————————————————————————————— */
  function getSqftPerBox(wrapper) {
    var v = parseFloat(wrapper.dataset.sqftPerBox || wrapper.dataset.sqftperbox || 0);
    return v > 0 ? v : null;
  }

  function getOrCreateResult(wrapper) {
    var el = wrapper.querySelector('.' + RESULT_CLASS);
    if (!el) {
      el = document.createElement('p');
      el.className = RESULT_CLASS;
      el.setAttribute('style', RESULT_STYLE);
      el.setAttribute('aria-live', 'polite');
      wrapper.appendChild(el);
    }
    return el;
  }

  function updateResult(input) {
    var wrapper = input.closest('[data-sqft-per-box],[data-sqftperbox]');
    if (!wrapper) return;
    var spb = getSqftPerBox(wrapper);
    if (!spb) return;

    var sqft   = parseFloat(input.value) || 0;
    var result = getOrCreateResult(wrapper);

    if (sqft <= 0) {
      result.textContent = '';
      return;
    }

    var boxes   = Math.ceil(sqft / spb);
    var covered = boxes * spb;
    var surplus = covered - sqft;

    result.innerHTML =
      '<strong>' + boxes + ' box' + (boxes !== 1 ? 'es' : '') + '</strong>' +
      ' &times; ' + spb + '\u00a0sqft/box = ' +
      '<strong>' + covered + '\u00a0sqft</strong>' +
      (surplus > 0
        ? ' <span style="color:#888">(' + surplus + '\u00a0sqft surplus)</span>'
        : '');
  }

  /* — wire up one sqft input ————————————————————————————————————— */

  function attachInput(input) {
    if (input._sqftPatched) return;
    input._sqftPatched = true;
    input.addEventListener('input', function () { updateResult(this); });
    input.addEventListener('change', function () { updateResult(this); });
    updateResult(input);
  }

  /* — intercept form submit: convert sqft → boxes ————————————————— */

  function attachFormIntercept(input) {
    if (input._sqftIntercepted) return;
    input._sqftIntercepted = true;

    var form = input.closest('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var wrapper = input.closest('[data-sqft-per-box],[data-sqftperbox]');
      if (!wrapper) return;
      var spb = getSqftPerBox(wrapper);
      if (!spb) return;

      var sqft = parseFloat(input.value) || 0;
      if (sqft <= 0) return;

      var boxes = Math.ceil(sqft / spb);

      // Overwrite the hidden [name="quantity"] field that Shopify reads
      var qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput) {
        qtyInput.value = boxes;
      }
    }, true); // capture phase – runs before theme handlers
  }

  /* — scan the DOM for sqft inputs ——————————————————————————————— */

  function scanAndAttach() {
    document.querySelectorAll('[data-sqft-input]').forEach(function (input) {
      attachInput(input);
      attachFormIntercept(input);
    });
  }

  /* — observe for dynamically-injected product forms ————————————— */

  function observe() {
    var mo = new MutationObserver(function (mutations) {
      var needsScan = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) needsScan = true;
        });
      });
      if (needsScan) scanAndAttach();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* — boot ————————————————————————————————————————————————————— */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanAndAttach();
      observe();
    });
  } else {
    scanAndAttach();
    observe();
  }

  // Re-scan after Shopify section re-renders (theme events)
  document.addEventListener('shopify:section:load', scanAndAttach);

})();